
import { httpRequest } from "../../utils/HttpRequest";
import { IKey, IPage, ISearchPage } from "../../types/ScmTypes";
export interface ITodayField {
    turnover: number // 809,
    turnoverNum: number // 1,
    maintenanceAmount: number // 809,
    maintenanceNum: number // 1,
    salesAmount: number // 0,
    salesNum: number // 0,
    warehousingAmount: number // 877485.94,
    warehousingNum: number // 4,
    deliveryAmount: number // 181.89,
    deliveryNum: number // 1
}
export interface IAmount {
    amount: number,  // 181.89,
    num: number,  // 1,
    day: string,  // "2021-03-04"
}
export interface IZhouField {
    [key: string]: IAmount[]
}
export interface IYerField {
    [key: string]: IAmount[]
}
class HomeService {
    async today() {
        const apiUrl = "/vrm-sa/statistics/today";
        return await httpRequest.post<ITodayField>(apiUrl);
    }
    async zhou() {
        const apiUrl = "/vrm-sa/statistics/zhou";
        return await httpRequest.post<IZhouField>(apiUrl);
    }
    async yer() {
        const apiUrl = "/vrm-sa/statistics/yer";
        return await httpRequest.post<IYerField>(apiUrl);
    }
    // async one(id: string) {
    //     const apiUrl = `/vrm-sa/stock/findById/${id}`;
    //     return await httpRequest.get<IHomeDetailID>(apiUrl);
    // }
}

export const homeService = new HomeService();